<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>图形监督设置</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="main-table">
            <div class="d-flex flex-align-center">
                培训过程中验证码验证&nbsp;&nbsp;<el-switch v-model="trainCodeSwitch" active-color="#13ce66" inactive-color="#ff4949">
                </el-switch> &nbsp;&nbsp;学员在培课程中，每&nbsp;&nbsp;
                <el-input-number v-model="trainCodeInterval" style="width: 100px;" controls-position="right" :min="1"
                    :step="1"></el-input-number>&nbsp;&nbsp;
                分钟出现图形验证码
            </div>
            <el-button type="primary" @click="submit()">确认</el-button>

        </div>
    </div>
</template>

<script>
import { configAdd, configList, configAddOrEdit } from '@/api/userMG.js'
export default {
    data () {
        return {
            trainCodeSwitch: false,
            trainCodeInterval: 30,
            isExist: false

        }
    },
    created () {
        this.getList()
    },
    methods: {
        async getList () {
            const res = await configList();
            this.isExist = !!res.data.length;
            res.data.forEach(item => {
                if (item.key == 'train-code-switch') {
                    this.trainCodeSwitch = JSON.parse(item.value || false);
                }
                if (item.key == 'train-code-interval') {
                    this.trainCodeInterval = item.value || 30;
                }
            })
        },
        async submit () {
            const params1 = {
                key: 'train-code-switch',
                value: this.trainCodeSwitch
            }
            const params2 = {
                key: 'train-code-interval',
                value: this.trainCodeInterval
            };
            if (this.isExist) {
                const res = await configAddOrEdit(params1);
                const res1 = await configAddOrEdit(params2);
                this.$message({ message: '更新成功', type: 'success' });
            } else {
                const res = await configAdd(params1);
                const res1 = await configAdd(params2);
                this.$message({ message: '保存成功', type: 'success' });
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.main-table {
    box-sizing: border-box;
    padding-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/system/graphics.vue